<template>
  <div>
    <Header title="教学评价"></Header>
    <div class="eva-detail">
      <p class="eva-num">
        <span>{{evaluateIndex + 1}}</span>
        /{{this.total}}
      </p>
      <!-- 选项评价 -->
      <div v-for="(item,index) in radioEvaluate" :key="index">
        <template>
          <p class="eva-topic">{{evaluateIndex == index ? item.targetName : ''}}</p>
        </template>
        <div class="eva-rate" v-if="evaluateIndex == index">
          <ul>
            <h1 class="dctitle">档次及分数线</h1>
            <div v-for="(oItem,index) in item.fszbList" :key="oItem.pjdcid">
              <p class="eva-topic" style="margin-bottom: 10px;font-weight: normal">
                {{oItem.dcmc}} {{oItem.fw1}}-{{oItem.fw2}}分
              </p>
            </div>
            <h2 class="dctitle" style="margin-top: 30px">分值：<input
              type="text"
              placeholder="请输入分值"
              class="fzinput"
              v-model.trim="fzvalue"
              @change="saveFz"
            /></h2>
          </ul>
        </div>
      </div>
      <!-- 建议textarea评价 -->
      <template v-if="evaluateIndex >= textIndex">
        <div v-for="(item,index) in textEvaluate" :key="item.suggestTypeId">
          <p class="eva-topic" v-if="evaluateIndex == index + textIndex">{{item.suggestTypeName}}</p>
          <div class="eva-rate" v-if="evaluateIndex == index + textIndex">
            <textarea name placeholder="请点击填写" v-model="evaText"></textarea>
            <span>{{calcNum()}}</span>
          </div>
        </div>
      </template>
    </div>

    <div class="eva-buttons">
      <button class="pre-topic" @click="preTopic()" v-if="evaluateIndex != 0">上一题</button>
      <button
        class="eva-btn"
        @click="nextTopic()"
        v-text="evaluateIndex + 1 == total ? '提交评教' : '下一题'"
        :style="evaluateIndex == 0 ? 'width:100%' : ''"
      ></button>
    </div>
  </div>
</template>

<script>
import { Api } from '../../../utils/axios'
export default {
  data() {
    return {
      evaluateIndex: 0,
      evaluateList: [],
      textEvaluate: [],
      radioEvaluate: [],
      evaText: '',
      total: '',
      optionList: [],
      pickOptVal: [],
      textVal: [],
      isCheck: null,
      textIndex: '',
      maxNum: '140',
        fzvalue:""
    }
  },
  created() {
    this.$store.state.evaOptCheck = [];
    this.getIndex()
  },
  methods: {
    calcNum() {
      this.maxNum = 140 - this.evaText.length;
      return this.maxNum
    },
    async getIndex() {
      const params = {
        batchId: this.$route.query.batchId,
        evaluationCategoriesId: this.$route.query.evaluationCategoriesId,
        courseId: this.$route.query.courseId,
        teacherId: this.$route.query.teacherId,
        noticeId: this.$route.query.noticeId,
        schoolClassificationId: this.$route.query.schoolClassificationId
      }
      const res = await Api.teachEvaluationIndex(params)
      this.textEvaluate = res.data.suggestData;
      for (let i = 0; i < res.data.targetData.length; i++) {
        if (res.data.targetData[i].fszbList.length>0) {
          this.radioEvaluate = this.radioEvaluate.concat(res.data.targetData[i])
        }
      }
      this.textIndex = this.radioEvaluate.length
      this.total = this.textEvaluate.length + this.radioEvaluate.length;
    },
    preTopic() {
      if (this.evaluateIndex > 0) {
        this.evaluateIndex--;
          if (this.evaluateIndex >= this.textIndex){
              this.evaText = this.textVal[this.evaluateIndex - this.textIndex].suggestval
          }else {
              this.fzvalue=this.pickOptVal[this.evaluateIndex].targetval;
          }

      }
    },
    async evaTap(e) {
      const data = e
      const res = await Api.teachSaveEvaluate(data)
      if (res.code == '1') {
        this.$toast.success('评教成功~')
        // setTimeout(() => {
        //   this.$router.push('/evaluate')
        // },1000)
        setTimeout(() => {
          this.$router.push({
            path: '/evaluate2',
            query: {
              'pj05id': this.$route.query.pj05id,
              'batchId': this.$route.query.batchId
            }
          })
        }, 1000)
      } else {
        this.$toast(res.errorMessage)
      }
    },
    nextTopic() {
      //无主观评价
      if (this.textEvaluate.length == 0) {
          if (this.fzvalue=="") {
              this.$toast.fail("请填写分值!");
              return false
          }
          var fzlist=this.radioEvaluate[this.evaluateIndex].fszbList;
          var isfwn=false;
          for(var index in  fzlist){
              let fw1=eval(fzlist[index].fw1)
              let fw2=eval(fzlist[index].fw2)
              if(this.fzvalue>=fw1&&this.fzvalue<=fw2){
                  isfwn=true;
              }
          }
          if(!isfwn){
              this.$toast.fail("分值不在分数段内!");
              return false
          }
          else if (this.fzvalue.split(".").length > 1 && this.fzvalue.split(".")[1].length>1) {
              this.$toast.fail("分值最多一位小数!");
              return false
          }

          if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
              this.pickOptVal[this.evaluateIndex].targetid = this.radioEvaluate[this.evaluateIndex].targetId,
                  this.pickOptVal[this.evaluateIndex].targetval = this.fzvalue;
          }else {
              this.pickOptVal.push({
                  targetid: this.radioEvaluate[this.evaluateIndex].targetId,
                  targetval: this.fzvalue
              });
          }

        if (this.evaluateIndex + 1 < this.total) {
          this.evaluateIndex += 1;
          if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
              this.fzvalue=this.pickOptVal[this.evaluateIndex].targetval
          }
          else{
              this.fzvalue=""
          }
        } else {
          let formData = {
            evaluationCategoriesId: this.$route.query.evaluationCategoriesId,
            target: this.pickOptVal,
            batchId: this.$route.query.batchId,
            teacherId: this.$route.query.teacherId,
            noticeId: this.$route.query.noticeId,
            schoolClassificationId: this.$route.query.schoolClassificationId,
            courseId: this.$route.query.courseId,
            suggest: [],
              pjfs:"1"
          }
          this.evaTap(formData)
        }
        //有主观评价
      }
      else {
        if (this.evaluateIndex < this.total - this.textEvaluate.length) {
            if (this.fzvalue=="") {
                this.$toast.fail("请填写分值!");
                return false
            } else {
                var fzlist=this.radioEvaluate[this.evaluateIndex].fszbList;
                var isfwn=false;
                for(var index in  fzlist){
                    let fw1=eval(fzlist[index].fw1)
                    let fw2=eval(fzlist[index].fw2)
                    if(this.fzvalue>=fw1&&this.fzvalue<=fw2){
                        isfwn=true;
                    }
                }
                if(!isfwn){
                    this.$toast.fail("分值不在分数段内!");
                    return false
                }
                else if (this.fzvalue.split(".").length > 1 && this.fzvalue.split(".")[1].length>1) {
                    this.$toast.fail("分值最多一位小数!");
                    return false
                }
                if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
                    this.pickOptVal[this.evaluateIndex].targetid = this.radioEvaluate[this.evaluateIndex].targetId,
                        this.pickOptVal[this.evaluateIndex].targetval = this.fzvalue;
                }else {
                    this.pickOptVal.push({
                        targetid: this.radioEvaluate[this.evaluateIndex].targetId,
                        targetval: this.fzvalue
                    });
                }
            this.evaluateIndex += 1;
            if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
                this.fzvalue=this.pickOptVal[this.evaluateIndex].targetval
            }
            else{
                this.fzvalue=""
            }
          }
        } else {
            if (this.evaText == "") {
                this.$toast.fail("请填写!!");
                return false;
            }
          this.textVal.push({
            suggestid: this.textEvaluate[this.evaluateIndex - this.textIndex].suggestTypeId,
            suggestval: this.evaText, // this.$store.state.evaTextList[this.textIndex - this.evaluateIndex]
          })
          this.evaText = ""
          let formData = {
            evaluationCategoriesId: this.$route.query.evaluationCategoriesId,
            target: this.pickOptVal,
            batchId: this.$route.query.batchId,
            teacherId: this.$route.query.teacherId,
            noticeId: this.$route.query.noticeId,
            schoolClassificationId: this.$route.query.schoolClassificationId,
            courseId: this.$route.query.courseId,
            suggest: this.textVal,
              pjfs:"1"
          }
          if (this.evaluateIndex + 1 < this.total) {
            this.evaluateIndex += 1;
          } else {
            this.evaTap(formData)
          }
        }
      }
    },
      saveFz(){
          if (this.pickOptVal[this.evaluateIndex] != null && this.pickOptVal[this.evaluateIndex] != undefined){
              this.pickOptVal[this.evaluateIndex].targetid = this.radioEvaluate[this.evaluateIndex].targetId;
              this.pickOptVal[this.evaluateIndex].targetval =this.fzvalue;
          }else {
              this.pickOptVal.push({
                  targetid: this.radioEvaluate[this.evaluateIndex].targetId,
                  targetval: this.fzvalue
              });
          }
      }
  },

}
</script>

<style lang="less" scoped>
.eva-detail {
  padding: 0 20px 50px;
}
.eva-detail .eva-num {
  color: @attendance-background-color-2;
  font-size: 18px;
}
.eva-detail .eva-num span {
  color: @attendance-background-color-1;
  font-size: 48px;
  font-weight: 600;
}
.eva-detail .eva-topic {
  color: @attendance-color-2;
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
}
.eva-detail .eva-rate {
  margin-top: 20px;
}
.eva-detail .eva-rate ul li {
  padding: 20px;
  font-weight: 600;
  border-radius: 5px;
  margin-bottom: 20px;
  background-color: @attendance-background-color-10;
  color: @attendance-color-1;
}
.eva-detail .eva-rate ul li.checked {
  padding: 20px;
  font-weight: 600;
  border-radius: 5px;
  margin-bottom: 20px;
  background-color: @attendance-background-color-12;
  color: @attendance-color-3;
}
.eva-detail .eva-rate textarea {
  width: 100%;
  padding: 20px;
  background-color: @attendance-background-color-6;
  border-radius: 3px;
  box-sizing: border-box;
  color: @attendance-color-1;
  height: 350px;
}
.eva-detail .eva-rate textarea::placeholder {
  color: @attendance-color-2;
}
.eva-detail .eva-rate {
  position: relative;
}
.eva-detail .eva-rate span {
  color: @attendance-color-2;
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.eva-buttons {
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  padding-bottom: 20px;
  background-color: @attendance-color-3;
}
.eva-buttons button {
  border-radius: 3px;
  padding: 11px 0;
  width: 45%;
}
.eva-buttons .eva-btn {
  background-color: @attendance-background-color-1;
  color: @attendance-color-3;
}
.eva-buttons .pre-topic {
  background-color: @attendance-background-color-6;
  color: @attendance-background-color-1;
}
.dctitle{
  color:@attendance-background-color-1;
  font-weight: normal;
  margin-bottom: 20px;
}
.fzinput{
  border: 1px @attendance-color-2 solid;
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/Evaluate/evaluate3fs.vue